import React from 'react';
import { Pagination } from '../types';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, IconButton, Stack, Typography } from '@mui/material';

interface Props {
  pagination: Pagination;
}

export const TablePagination = ({ pagination: { total, page, perPage, onChange } }: Props) => {
  const totalPages = Math.ceil(total / perPage);
  const from = Math.min((page - 1) * perPage + 1, total);
  const to = Math.min(page * perPage, total);

  return (
    <Box className="listing-pagination">
      <Stack direction="row" alignItems="center" justifyContent="center" gap={1}>
        <Typography variant="body2" color="text.secondary">
          {from}–{to} of {total}
        </Typography>

        <IconButton size="small" onClick={() => onChange(page - 1)} disabled={page <= 1}>
          <ChevronLeftIcon fontSize="small" />
        </IconButton>

        <IconButton size="small" onClick={() => onChange(page + 1)} disabled={page >= totalPages}>
          <ChevronRightIcon fontSize="small" />
        </IconButton>
      </Stack>
    </Box>
  );
};
